import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '../../ui/button';
import { Phone, ChevronDown } from 'lucide-react';

function TopLink({ active, onClick, children, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`relative px-3 py-2 text-[13px] font-medium tracking-[0.02em] transition-colors duration-200 rounded-md hover:bg-white/10 ${
        active ? 'text-[#7fb2e3]' : 'text-white/80 hover:text-white'
      }`}
    >
      {children}
    </button>
  );
}

export default function NavLinks({ groups, isHome, activeSection, onScrollItemClick, onPageItemClick }) {
  const location = useLocation();

  const isItemActive = (item) =>
    item.type === 'page' ? location.pathname === item.path : isHome && activeSection === item.id;
  const isGroupActive = (g) => g.items && g.items.some(isItemActive);

  return (
    <div className="hidden lg:flex items-center gap-0.5">
      {groups.map((g) => {
        if (!g.items) {
          return (
            <TopLink
              key={g.key}
              active={location.pathname === g.path}
              onClick={() => onPageItemClick(g.path)}
              testId={`site-nav-${g.key}-link`}
            >
              {g.label}
            </TopLink>
          );
        }
        return (
          <div key={g.key} className="relative group">
            <button
              className={`flex items-center gap-1.5 px-3 py-2 text-[13px] font-medium tracking-[0.02em] rounded-md transition-colors duration-200 hover:bg-white/10 ${
                isGroupActive(g) ? 'text-[#7fb2e3]' : 'text-white/80 hover:text-white'
              }`}
              data-testid={`site-nav-${g.key}-trigger`}
              aria-haspopup="true"
            >
              {g.label}
              <ChevronDown className="w-3.5 h-3.5 transition-transform duration-200 group-hover:rotate-180 group-focus-within:rotate-180" />
            </button>
            <div className="absolute top-full left-0 pt-3 opacity-0 invisible translate-y-1 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 group-focus-within:opacity-100 group-focus-within:visible group-focus-within:translate-y-0 transition-[opacity,transform] duration-200 z-50">
              <div className="min-w-[210px] rounded-xl border border-white/10 bg-[hsl(var(--coal-2))] shadow-elev-2 p-1.5">
                {g.items.map((item) => (
                  <button
                    key={item.label}
                    onClick={() => (item.type === 'scroll' ? onScrollItemClick(item.id) : onPageItemClick(item.path))}
                    data-testid={item.testId || `site-nav-${g.key}-${item.id || item.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className={`w-full text-left px-3 py-2.5 rounded-lg text-[13px] transition-colors duration-200 ${
                      isItemActive(item)
                        ? 'text-[#7fb2e3] bg-white/5'
                        : 'text-white/80 hover:text-white hover:bg-white/10'
                    }`}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        );
      })}
      <a href="tel:5014507538" className="ml-2">
        <Button
          size="sm"
          className="btn-lift gap-2 rounded-lg bg-[hsl(var(--water-blue-2))] hover:bg-[hsl(var(--water-blue))] text-white h-9 px-4 text-[13px]"
          data-testid="site-nav-call-button"
        >
          <Phone className="w-3.5 h-3.5" />
          (501) 450-7538
        </Button>
      </a>
    </div>
  );
}
